import Player from '@/utils/player'
export * from './resType'

// 默认标题
export const defaultTitle = 'HSK Mock: the only official platform for practising HSK and YCT tests'

// 全局音频播放器
export const player = new Player()

// 模块
export const MODULE_NAME = {
  SKILLUP: '100',
  VOCABULARY: '101',
  CEFR: '200',
  CEFR_EXAM: '201',
  TEXTBOOK: '300',
  EIKEN: '400',
  EIKEN_SUGGEST_1ST_EXAM: '401', // 试验对策 => 英检=> 一次试验
  EIKEN_SUGGEST_1ST_EXAM_REVIEW: '402', // 试验对策 => 英检=> 一次试验水平测试
  EIKEN_SUGGEST_WORD: '403', // 试验对策 => 英检=> 单语特训
  EIKEN_SUGGEST_WORDLEARN: '404', // 试验对策 => 英检=> 单语学习
  EIKEN_COMMON_TEST_LISTEN: '420', // 试验对策 => 共通test => 听力
  HOMEWORK: '500',
  AI_STUDY_COURSE_PRACTICE: 600, // ai课练习模块
  AI_STUDY_COURSE_TESTING: 601, // ai课测试模式
  HSK: '301',
}
export const BASE_CONFIG = {
  excellent_score: parseInt(localStorage.getItem('excellent_score')) || 80,
  standard_score: parseInt(localStorage.getItem('standard_score')) || 60,
  result: {
    // perfect: require('@/media/stamp_perfect_zh.m4a'),
    // welldone: require('@/media/stamp_welldone_zh.m4a'),
    // notbad: require('@/media/stamp_notbad_zh.m4a'),
    // bad: require('@/media/stamp_bad_zh.m4a'),
    // right: require('@/media/right.mp3'),
    // error: require('@/media/error.mp3'),
  },
  media: {
    // bee: require('@/media/bee.mp3'),
    // n1: require('@/media/n1.mp3'),
    // n2: require('@/media/n2.mp3'),
  },
}
export const API_BASE_URL =
  process.env.VUE_APP_MODE === 'prod'
    ? process.env.VUE_APP_ENVIRONMENT === 'china'
      ? 'https://api.hskmock.cn/mock'
      : 'https://api.hskmock.com/mock'
    : process.env.VUE_APP_ENVIRONMENT === 'china'
    ? 'https://staging-api.hskmock.cn/mock'
    : 'https://staging-api.hskmock.com/mock'

export const CLIENT = 'whzw PC'

export const testConfig = {
  HSK: 1,
  HSKK: 2,
  YCT: 3,
  HSK3: 4,
  'NEW-HSK': 4, // 路由别名，指向 HSK3.0
  'NEW-HSKK': 5,
}
// 根据环境区分地址
export const pathUrl = {
  MOCK:
    process.env.VUE_APP_MODE === 'prod'
      ? process.env.VUE_APP_ENVIRONMENT === 'china'
        ? 'https://www.hskmock.cn/home/index'
        : 'https://www.hskmock.com/home/index'
      : process.env.VUE_APP_ENVIRONMENT === 'china'
      ? 'https://staging.hskmock.cn/home/index'
      : 'https://staging.hskmock.com/home/index',
  WOHUI:
    process.env.VUE_APP_MODE === 'prod'
      ? process.env.VUE_APP_ENVIRONMENT === 'china'
        ? 'https://app.wohuimandarin.cn'
        : 'https://app.wohuimandarin.com'
      : process.env.VUE_APP_ENVIRONMENT === 'china'
      ? 'https://staging-app.wohuimandarin.cn'
      : 'https://staging-app.wohuimandarin.com',
}

// 使用新加坡币的国家

export const USE_S$_COUNTRY_LIST = ['新加坡']

// 音频留白时间（HSK 1.0/2.0）
export const VOICE_EXTEND_TIME = 7

// 音频留白时间（HSK 3.0）
export const VOICE_EXTEND_TIME_HSK3 = 0

export const IS_CHINA = process.env.VUE_APP_ENVIRONMENT === 'china'
